import { Dispatch } from "redux";
import { StatisticsActions, StatisticsActionTypes } from "./types";
import { fetchError } from "./all";
import { IDType } from "../../config/types";
import client from "../../client";

export function statisticsId(leagueId: IDType, teamId?: IDType): string {
  if (teamId) {
    return `${leagueId}_${teamId}`;
  }
  return `${leagueId}`;
}

export function fetchPlayerStatistics(
  dispatch: Dispatch<StatisticsActions>,
  leagueId: IDType,
  teamId?: IDType,
  limit = 3,
) {
  const key = statisticsId(leagueId, teamId);
  dispatch({ type: StatisticsActionTypes.FETCH_PLAYER });
  client()
    .fetchPlayerStatistics(leagueId, teamId, limit)
    .then(
      (response) => {
        dispatch({
          type: StatisticsActionTypes.FETCH_PLAYER_SUCCESS,
          payload: {
            key,
            response,
            fetchDate: new Date(),
          },
        });
      },
      (error) => {
        fetchError(error, StatisticsActionTypes.FETCH_ERROR_PLAYER, dispatch);
      }
    );
}

